import Button from "components/global/Button";
import Spacer from "components/global/Spacer";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  // min-height: 100vh;
  padding-block: 48px;

  .cardContainer {
    max-width: 508px;
  }

  .card {
    width: 100%,
    max-width: 604px;
    padding: 48px;
    background-color: #021128;
    border-radius: 24px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }

  .input {
    width: 100%;
    height: 48px;
    padding: 10px;
    border: 1px solid #021128,
    border-radius: 5px;
    paddingLeft: 10px;
    color: var(--grey_1);
  }

  .subContainer {
    margin-block: 48px;
  }

  .priceContainer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 24px;
  }

  .priceContainerInner {
    flex: 1;
    background-color: #0F1D33;
    padding: 12px;
    border-radius: 4px;             
  }

  @media screen and (max-width: 480px) {
    padding: 0;

    .card {
      border-radius: 0;
      padding: 48px 24px;
    }

    .priceContainer {
      flex-direction: column;
    }
  }
`;

const AffiliateEarningCalculator = () => {
  const [inputValue, setInputValue] = useState(0);
  const [monthlyEarning, setMonthlyEarning] = useState(0);

  const formatNumber = (number) => {
    if (number >= 1000000000000) {
      return (number / 1000000000000).toFixed(1) + "t";
    } else if (number >= 1000000000) {
      return (number / 1000000000).toFixed(1) + "b";
    } else if (number >= 1000000) {
      return (number / 1000000).toFixed(1) + "m";
    } else if (number >= 100000) {
      return (number / 1000).toFixed(1) + "k";
    } else {
      return number?.toFixed(0);
    }
  };

  const isUserInNigeria = () => {
    const userCountryCode = new Intl.DateTimeFormat().resolvedOptions()
      .timeZone;
    return userCountryCode === "Africa/Lagos";
  };

  const nigerianUser = isUserInNigeria();
  
  useEffect(() => {
    if (nigerianUser) {
      setMonthlyEarning(inputValue * 0.3 * 0.1 * 7500);
    } else {
      setMonthlyEarning(inputValue * 0.3 * 0.1 * 12);
    }
  }, [inputValue, nigerianUser]);

  return (
    <Wrapper className="colorWhite flexRow justifyCenter alignCenter bgWhite body-2">
      <div className="card">
        <div className="cardContainer">
          <p className="l2 textUppercase textCenter colorWhite">
            Calculate your Expected Earnings
          </p>
          <Spacer y={4.8} />
          <label className="l2">Average likes per post</label>
          <Spacer y={0.4} />
          <input
            type="number"
            min={0}
            max={100000000}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="e.g 120,000"
            className="input"
          />

          <div className="subContainer">
            <p className="l2">You can get a payout of up to</p>
            <Spacer y={1.2} />
            <div className="priceContainer">
              <div className="priceContainerInner">
                <h2 className="colorWhite">
                  {nigerianUser ? "₦" : "$"}
                  {formatNumber(monthlyEarning)}
                </h2>
                <p className="body-3">per month</p>
              </div>

              <div className="priceContainerInner">
                <h2 className="colorWhite">
                  {nigerianUser ? "₦" : "$"}
                  {formatNumber(monthlyEarning * 12)}
                </h2>
                <p className="body-3">per year</p>
              </div>
            </div>
            <Spacer y={1.2} />
            <p className="textDescription">
              Expectations: At least 10% of Average Engagements will become
              paying users on the lowest plan.
            </p>
          </div>

          <Button
            onClick={() =>
              window.open("https://forms.gle/TJCkEeZWU9jFpd9K7", "_blank")
            }
            text="Start earning"
            bg="var(--secondary)"
            className=" l3"
            fullWidth
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default AffiliateEarningCalculator;
